import { render, staticRenderFns } from "./pageSetting.vue?vue&type=template&id=0937efe9&scoped=true&"
import script from "./pageSetting.vue?vue&type=script&lang=js&"
export * from "./pageSetting.vue?vue&type=script&lang=js&"
import style0 from "./pageSetting.vue?vue&type=style&index=0&id=0937efe9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937efe9",
  null
  
)

export default component.exports